// Tools: Helper functions used within actions.

/* Request Headers */
export const getRequestHeaders = (bankregnr: string | null): { headers: { [key: string]: string } } => ({
    headers: {
        'X-BankRegNr': bankregnr || '',
        'Content-Type': 'application/json',
        'X-Requested-By': 'salgspantlaan-js-client',
    },
});

/* Check Local */
export const isLocal = () =>
    window.location.hostname === 'local.portalbank.no' ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '10.0.2.2';
